/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const pause_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7.833 3H6.167C5.247 3 4.5 3.733 4.5 4.636v14.728c0 .903.746 1.636 1.667 1.636h1.666c.92 0 1.667-.733 1.667-1.636V4.636C9.5 3.733 8.754 3 7.833 3Zm10 0h-1.666c-.92 0-1.667.733-1.667 1.636v14.728c0 .903.746 1.636 1.667 1.636h1.666c.92 0 1.667-.733 1.667-1.636V4.636C19.5 3.733 18.754 3 17.833 3Z"
    />
  </svg>
)
export default pause_medium
